module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "alert alert-dismissible",
    class: {
      'alert-success': _vm.type === 'success', 'alert-danger': _vm.type === 'error', 'alert-warning': _vm.type === 'warning'
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTitle),
      expression: "showTitle"
    }]
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', [_vm._v(_vm._s(_vm.msg))]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.closeFunction),
      expression: "closeFunction"
    }],
    staticClass: "close mdi mdi-close action-icon",
    on: {
      "click": function($event) {
        _vm.closeFunction()
      }
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d5c52ef","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/Alert.vue
// module id = 487
// module chunks = 1